export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const DETAIL_PROFILE = "DETAIL_PROFILE";
export const GET_AIRPORT = "GET_AIRPORT";
export const GET_AIRPORTBYID = "GET_AIRPORTBYID";
export const ADD_AIRPORT = "ADD_AIRPORT";
export const PUT_AIRPORT = "PUT_AIRPORT";
export const DELETE_AIRPORT = "DELETE_AIRPORT";
export const GET_AIRPLANE = "GET_AIRPLANE";
export const ADD_AIRPLANE = "ADD_AIRPLANE";
export const PUT_AIRPLANE = "PUT_AIRPLANE";
export const DELETE_AIRPLANE = "DELETE_AIRPLANE";
export const GET_AIRPLANEBYID = "GET_AIRPLANEBYID";
export const GET_DESTINASI = "GET_DESTINASI";
export const ADD_DESTINASI = "ADD_DESTINASI";
export const PUT_DESTINASI = "PUT_DESTINASI";
export const DELETE_DESTINASI = "DELETE_DESTINASI";
export const GET_DESTINASIBYID = "GET_DESTINASIBYID";
export const ABOUT_US = "ABOUT_US";
export const GET_TICKET = "GET_TICKET";
export const FILTER_TICKET = "FILTER_TICKET";
export const ADD_TICKET = "ADD_TICKET";
export const PUT_TICKET = "PUT_TICKET";
export const DELETE_TICKET = "DELETE_TICKET";
export const GET_TICKETBYID = "GET_TICKET_ID";
export const GET_TICKETDETAIL = "GET_TICKETDETAIL";
export const GET_USERS = "GET_USERS";
export const ADD_ADMIN = "ADD_ADMIN";
export const GET_NOTIF = "GET_NOTIF";
export const UPDATE_NOTIF = "UPDATE_NOTIF";
export const GET_WISHLIST = "GET_WIHSLIST";
export const ADD_WISHLIST = "ADD_WISHLIST";
export const DELETE_WISHLIST = "DELETE_WISHLIST";
export const PROCEED_PAYMENT = "PROCEED_PAYMENT";
export const PROCEED_TRANSACTION = "PROCEED_TRANSACTION";
export const GET_HISTORY = "GET_HISTORY";
export const SEE_NOTIF = "SEE_NOTIF";
export const GET_ORDERS = "GET_ORDERS";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const COUNT_NOTIF = "COUNT_NOTIF";
export const DASHBOARD_ADMIN = "DASHBOARD_ADMIN";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";